import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { CoreTracking } from "../../../models/CoreTracking";
import { RequestState } from "../../../models/RequestState";
import { GetUserTrackings } from "../../../store/UserAction";
import TrackingsModule from "../components/TrackingsModule";
import { useTranslation } from 'react-i18next';
import { RootState } from "../../../store/store";



const UserViewTrackings = () => {
    const { t } = useTranslation(['schoolAdministration']);

    const { userId } = useParams();
    const dispatch = useDispatch();
    const trackings = useSelector<RootState, RequestState<CoreTracking[]>>(state => state.users.userTrackings);

    useEffect(() => {
        if (userId !== undefined) {
            GetUserTrackings(userId)(dispatch);
        }
    }, [dispatch, userId]);

    const fetchTrackings = () => {
        if (userId !== undefined) {
            GetUserTrackings(userId, true)(dispatch);
        }
    }

    return (<>
        <TrackingsModule
            trackings={trackings}
            noResMsg={t('trackingModule.noResMsg', { ns: 'schoolAdministration', type: t('type.person', { ns: 'schoolAdministration' }) })}
            onDataInvalidated={fetchTrackings}
        />
    </>);
}

export default UserViewTrackings;
